export type FloorValue = 'souterrain' | 'ground' | 'first' | 'second' | 'third' | 'fourth' | 'garden'

export const FLOOR_ORDER: FloorValue[] = ['ground', 'first', 'second', 'third', 'fourth', 'souterrain', 'garden']

// in-flight requests per floor, so a preload and a mounting floor share one request
const inFlight = new Map<string, Promise<string>>()

/**
 * Floorplan SVG markup, fetched once per floor and kept in useState for the rest of the
 * visit — the plans are static, so re-fetching them on every visit to /rooms is wasted time.
 */
export const useFloorSvgs = () => {
  const svgs = useState<Record<string, string>>('floor-svgs', () => ({}))

  const load = async (floor: FloorValue | string): Promise<string> => {
    const cached = svgs.value[floor]
    if (cached) return cached

    const existing = inFlight.get(floor)
    if (existing) return existing

    const request = $fetch<string>(`/api/floor-svg/${floor}`, { responseType: 'text' })
      .then((svg) => {
        svgs.value[floor] = svg
        return svg
      })
      .catch(() => '')
      .finally(() => {
        inFlight.delete(floor)
      })

    inFlight.set(floor, request)
    return request
  }

  const preload = (floors: (FloorValue | string)[] = FLOOR_ORDER) =>
    Promise.all(floors.map(floor => load(floor)))

  return { svgs, load, preload }
}
